<template>
  <svg width="25" height="24" viewBox="0 0 25 24">
    <path
      d="M10.448 8.11 8.703 4.178a.73.73 0 0 0-.922-.383c-1.935.722-2.86 1.832-2.776 3.329.094 1.657 1.239 3.744 2.438 5.477l.3.425c.151.209.301.41.448.605l.291.376.282.352c.046.057.09.112.136.166l.89 1.056.423.493.3.341.156.173.32.347c1.419 1.51 3.2 3.03 5.15 3.276 1.76.222 3.026-.528 3.799-2.25a.71.71 0 0 0-.287-.901L16.38 15.1a.734.734 0 0 0-.443-.101l-2.032.186a1.46 1.46 0 0 1-1.246-.506l-2.613-3.071a1.416 1.416 0 0 1-.222-1.483l.627-1.447a.707.707 0 0 0-.002-.569z"
      fill="#1D1D20"
      fill-rule="evenodd"
    />
  </svg>
</template>
